var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { SegmentWrapper as Component, SegmentBlock, SegmentLabel, SegmentPointer } from './ProgressBar.styled';
import { Tooltip } from '@citrus/tooltip';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import { getSegmentColor } from './private/_utils';
import { small as smallCss } from '../styles/legacy';
import { small as smallCssCitron } from '../styles/citron';
import { useTheme } from '@citrus/user';
var VERSION = '4.6.0';
var Segment = function (_a) {
    var _b;
    var automationId = _a.automationId, className = _a.className, color = _a.color, css = _a.css, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _c = _a.hideLabel, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hideLabel = _c === void 0 ? false : _c, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _d = _a.hideTooltip, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hideTooltip = _d === void 0 ? false : _d, label = _a.label, _e = _a.small, small = _e === void 0 ? false : _e, tooltip = _a.tooltip, value = _a.value, _f = _a.__hideLabels, __hideLabels = _f === void 0 ? false : _f, _g = _a.__hideTooltips, __hideTooltips = _g === void 0 ? false : _g, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _h = _a.__first, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __first = _h === void 0 ? false : _h, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _j = _a.__last, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __last = _j === void 0 ? false : _j, _k = _a.__TYPE, TYPE = _k === void 0 ? 'Segment' : _k, other = __rest(_a, ["automationId", "className", "color", "css", "hideLabel", "hideTooltip", "label", "small", "tooltip", "value", "__hideLabels", "__hideTooltips", "__first", "__last", "__TYPE"]);
    var debug = useCitrusDebug();
    var itemRef = useRef(null);
    var isCitron = useTheme().citrus2022;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var smallStyles = isCitron ? smallCssCitron : smallCss;
    var tooltipId = "segment-tooltip-".concat(value, "-").concat(Math.floor(Math.random() * 100000));
    var labelTooltipId = "segment-label-tooltip-".concat(value, "-").concat(Math.floor(Math.random() * 100000));
    var barStyles = {
        width: '100%',
        backgroundColor: getSegmentColor(color, isCitron),
    };
    var styles = small ? __assign(__assign({}, barStyles), smallStyles) : barStyles;
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, __assign({ className: classes, ref: itemRef, style: { width: value + '%' } }, other, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
            React.createElement(SegmentBlock, { "data-citrus-tooltip": tooltipId, style: styles }),
            !__hideLabels && (React.createElement(React.Fragment, null,
                React.createElement(SegmentPointer, null),
                React.createElement(SegmentLabel, { "data-citrus-tooltip": labelTooltipId }, label),
                !__hideTooltips && (React.createElement(Tooltip, { id: labelTooltipId, location: "bottom-start" }, tooltip !== null && tooltip !== void 0 ? tooltip : label))))),
        !__hideTooltips && (React.createElement(Tooltip, { id: tooltipId, location: "bottom" }, tooltip !== null && tooltip !== void 0 ? tooltip : label))));
};
Segment.defaultProps = {
    __TYPE: 'Segment',
};
export default Segment;
